// src/Auth.js
import React, { useState } from 'react';
import { auth } from './firebaseConfig';
import {
    signInWithEmailAndPassword,
    signOut
} from 'firebase/auth';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';

const Auth = ({ user }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [authError, setAuthError] = useState('');

    const handleLogin = async () => {
        setAuthError('');
        try {
            await signInWithEmailAndPassword(auth, email, password);
            alert('Logged in successfully!'); // Using alert for simplicity as per previous versions
        } catch (error) {
            console.error("Error logging in:", error);
            setAuthError(error.message);
        }
    };

    const handleLogout = async () => {
        setAuthError('');
        try {
            await signOut(auth);
            alert('Logged out successfully!'); // Using alert for simplicity as per previous versions
        } catch (error) {
            console.error("Error logging out:", error);
            setAuthError(error.message);
        }
    };

    return (
        <Container className="my-4">
            <Card className="p-4 shadow-sm">
                <Card.Body className="text-center">
                    {user ? (
                        <>
                            <Card.Title className="mb-3">Tervetuloa, {user.email || 'Anonymous User'}!</Card.Title>
                            <Button variant="danger" onClick={handleLogout}>Kirjaudu ulos</Button>
                        </>
                    ) : (
                        <>
                            <Card.Title className="mb-3">Kirjaudu</Card.Title>
                            <Form>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Control
                                        type="email"
                                        placeholder="Sähköposti"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Control
                                        type="password"
                                        placeholder="Salasana"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </Form.Group>
                                <div className="d-grid gap-2 d-md-flex justify-content-md-center">
                                    <Button variant="primary" onClick={handleLogin}>Kirjaudu</Button>
                                </div>
                            </Form>
                            {authError && <Alert variant="danger" className="mt-3">{authError}</Alert>}
                        </>
                    )}
                </Card.Body>
            </Card>
        </Container>
    );
};

export default Auth;